export default __webpack_public_path__ + "static/media/mbata.aade8c3b.jpg";